export const OTHER_TYPE = 'Other';
export const MAX_INFERRED_NAV_ITEMS = 6;

export type NavScope = 'assets' | 'sites' | 'contacts';

export function getShowAllConfig(scope: NavScope, tenantKey: string) {
  const keyMap: Record<
    NavScope,
    { normalized: string; legacy: string; event: string }
  > = {
    assets: {
      normalized: `tid:${tenantKey}:assetNavShowAll`,
      legacy: `config.assetNavShowAll.${tenantKey}`,
      event: 'assetNavShowAllChanged',
    },
    sites: {
      normalized: `tid:${tenantKey}:siteNavShowAll`,
      legacy: `config.siteNavShowAll.${tenantKey}`,
      event: 'siteNavShowAllChanged',
    },
    contacts: {
      normalized: `tid:${tenantKey}:contactsNavShowAll`,
      legacy: `config.contactsNavShowAll.${tenantKey}`,
      event: 'contactsNavShowAllChanged',
    },
  };
  return keyMap[scope];
}

export function writeShowAllToStorage(
  scope: NavScope,
  tenantKey: string,
  next: boolean,
  localStorage: { set: (key: string, value: string) => void }
) {
  const { normalized, legacy, event } = getShowAllConfig(scope, tenantKey);
  try {
    localStorage.set(normalized, next ? 'true' : 'false');
    localStorage.set(legacy, next ? 'true' : 'false');
    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent(event, { detail: { key: normalized, value: next } })
      );
    }
  } catch {
    // ignore storage/dispatch failures
  }
}
